<template>

  <div>
    
    <div class="card mb-3">
      <div class="card-header">
        {{ $t('General information') }}
      </div>
      <div class="card-body">
        <label><strong>{{ $t('Hiring manager') }}</strong></label>
        <p>{{ requisition.hiring_manager_name }}, <a :href="'mailto:'+requisition.hiring_manager_email">{{ requisition.hiring_manager_email }}</a></p>

        <label><strong>{{ $t('Location') }}</strong></label>
        <p>
          {{ location || 'N/D' }}
          <span v-if="requisition.workplace_type">
            ({{ $t({ 'on-site': 'On-site', 'remote': 'Remote', 'hybrid': 'Hybrid' }[requisition.workplace_type]) }})
          </span>
        </p>
        
        <label><strong>{{ $t('Remuneration') }}</strong></label>
        <p v-if="requisition.remuneration">
          <span v-if="requisition.remuneration">{{ $n(requisition.remuneration, {style: 'currency', currency: requisition.currency}) }}</span>
          <span v-if="requisition.remuneration_max">até {{ $n(requisition.remuneration_max, {style: 'currency', currency: requisition.currency}) }}</span>
          <span v-if="remunerationPeriod"> ({{ remunerationPeriod }}) </span>
          <span v-if="requisition.contract_id"> - {{ requisition.contract_id.name }}</span>
        </p>
        <p v-if="!requisition.remuneration">{{ 'N/D' }}</p>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        {{ $t('Description') }}
      </div>
      <div class="card-body">
        <div v-html="requisition.description"></div>
      </div>
      <div class="card-header">
        {{ $t('Requirements') }}
      </div>
      <div class="card-body">
        <div v-html="requisition.requirements"></div>
      </div>
      <div class="card-header">
        {{ $t('Benefits') }}
      </div>
      <div class="card-body">
        <div v-html="requisition.benefits"></div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        {{ $t('Comments') }}
      </div>
      <div class="card-body">
        <span style="white-space: pre-wrap;">{{ requisition.comments }}</span>
      </div>
    </div>

    <custom-view
      :fieldsValue="requisition.custom_fields" 
      :modelType="'requisition'">
      </custom-view>

    <div class="card mb-3">
      <div class="card-header">
        {{ $t('Details') }}
      </div>
      <div class="card-body">
        <label><strong>{{ $t('Professional category') }}</strong></label>
        <p>{{ positionCategory ? positionCategory.name : '--' }}</p>

        <label><strong>{{ $t('Experience level') }}</strong></label>
        <p>{{ experienceLevel ? experienceLevel.name : '--' }}</p>

        <label><strong>{{ $t('Last education') }}</strong></label>
        <p>{{ educationDegree ? educationDegree.name : '--' }}</p>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        {{ $t('Control') }}
      </div>
      <div class="card-body">
        <div class="grid-view"> 
          <label><strong>{{ $t('Owner') }}</strong></label>
          <p v-if="requisition.owner_user_id">{{ requisition.owner_user_id.name }}</p>

          <label><strong>{{ $t('Created at') }}</strong></label>

          <p>{{ $d(new Date(requisition.created_at), 'short') }} por {{ requisition.author_user_id.name }}</p>

          <label><strong>{{ $t('Job') }}</strong></label>
          <p v-if="!requisition.job">Não aberta</p>
          <p v-if="requisition.job"><router-link :to="{path: '/job/' + requisition.job._id}">{{ requisition.job.title }}</router-link></p>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import CustomView from '@/components/Parts/CustomView'

export default {
  name: 'RequisitionProfile',
  props: {
    requisition: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: {
    CustomView
  },
  data () {
    return {
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    location () {
      return [
        this.requisition.address,
        this.requisition.neighborhood,
        this.requisition.city,
        this.requisition.region,
        this.requisition.country,
        this.requisition.zipcode
      ]
      .filter(v => v)
      .join(', ')
    },
    remunerationPeriod () {
      return {
        hour: this.$t('Hour'),
        month: this.$t('Month'),
        year: this.$t('Year')
      }[this.requisition.remuneration_period]
    },
    positionCategory () {
      return this.resources.position_category.find((val) => {
        return val.key === this.requisition.position_category
      })
    },
    experienceLevel () {
      return this.resources.experience_level.find((val) => {
        return val.key === this.requisition.experience_level
      })
    },
    educationDegree () {
      return this.resources.education_degree.find((val) => {
        return val.key === this.requisition.education_degree
      })
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Requisition/RequisitionProfile.vue